<template>
  <router-view />
</template>
<script>
export default {
  name: "personnel",
};
</script>